<template>
    <v-app class="app-container">
        <v-container class="custom-container" :class="isLoggedIn ? '' : 'bg'" fluid>
            <div v-if="isLoggedIn" class="px-0 mx-0">
                <topbar />
            </div>
            <div :class="isLoggedIn ? 'main-router' : 'main-router2'" @click="setDrawer">
                <sidebar v-if="isLoggedIn" />
                <router-view :key="$route.path" />
            </div>
        </v-container>
        <v-btn
            v-show="fab"
            v-scroll="onScroll"
            fab
            dark
            fixed
            bottom
            right
            color="black"
            @click="toTop"
        >
            <v-icon large>mdi-chevron-up</v-icon>
        </v-btn>
    </v-app>
</template>

<script>
    import Sidebar from '@/components/Sidebar'
    import Topbar from '@/components/Topbar'
    import jwtUtil from '@/utils/jwtUtil'
    import geolocation from '@/utils/geolocation'
    import theming from '@/services/theming'
    import config from '@/services/config'
    const COMPANY_NAME = process.env.VUE_APP_ENV_COMPANY_NAME
    export default {
        name: 'App',
        components: {
            Sidebar,
            Topbar
        },
        data: () => ({
            interval: null,
            fab: false,
            config: null
        }),
        computed: {
            isLoggedIn() {
                return this.$store.getters.isLoggedIn
            },
            jwtToken() {
                return this.$store.getters.getToken
            },
            drawer: {
                get() {
                    return this.$store.getters.getDrawer
                },
                set(value) {
                    return value
                }
            }
        },
        watch: {
            $route() {
                document.title = `${this.capitalizeUnicode(COMPANY_NAME)} - ${this.$route.name}`
            },
            isLoggedIn() {
                if (!this.isLoggedIn) {
                    return
                }
                this.getUserTheming()
                this.getConfig()
            }
        },
        created() {
            geolocation.getCoordinates()
            if (this.isLoggedIn) {
                this.interval = setInterval(() => {
                    this.checkJwt()
                }, 7000)
                this.getUserTheming()
                this.getConfig()
            }
        },
        methods: {
            capitalizeUnicode(str) {
                return str ? str[0].toLocaleUpperCase() + str.slice(1) : ''
            },
            getConfig() {
                config.getConfig().then(resp => {
                    this.config = resp.data
                    this.$store.dispatch('setConfig', this.config)
                })
            },
            setDrawer() {
                if (this.drawer) {
                    this.$store.dispatch('setDrawer', !this.drawer)
                }
            },
            onScroll(e) {
                if (typeof window === 'undefined') return
                const top = window.pageYOffset || e.target.scrollTop || 0
                this.fab = top > 20
            },
            toTop() {
                this.$vuetify.goTo(0)
            },
            checkJwt() {
                if (jwtUtil.isJwtExpired(this.jwtToken)) {
                    this.$store.dispatch('logout').then(() => this.$router.push({ path: '/login' }))
                    clearInterval(this.interval)
                }
            },
            setInitialCssVars(themingConfig) {
                const bodyStyles = document.body.style
                const backgroundColor = themingConfig.backgroundColor || '#ffffff'
                const topBarColor = themingConfig.topBarColor || '#ffffff'
                const sideBarColor = themingConfig.sideBarColor || '#ffffff'
                const cardsAndTablesColor = themingConfig.cardsAndTablesColor || '#ffffff'
                const cardsAndTablesText = themingConfig.cardsAndTablesText || '#000000'
                const sideBarText = themingConfig.sideBarText || '#000000'
                bodyStyles.setProperty('--topbar-color', topBarColor)
                bodyStyles.setProperty('--cards-and-tables-text-color', cardsAndTablesText)
                bodyStyles.setProperty('--sidebar-color', sideBarColor)
                bodyStyles.setProperty('--cards-and-tables-color', cardsAndTablesColor)
                bodyStyles.setProperty('--sidebar-text-color', sideBarText)
                bodyStyles.setProperty('--background-color', backgroundColor)
            },
            getUserTheming() {
                this.setInitialCssVars({})
                theming.getTheming().then(resp => {
                    if (resp.data.config) {
                        this.$store.dispatch('setTheming', JSON.stringify(resp.data.config))
                        this.setInitialCssVars(resp.data.config)
                    }
                })
            }
        }
    }
</script>

<style>
    html {
        scrollbar-width: thin !important;
        scrollbar-color: #888 white;
    }

    .bg {
        width: 100%;
        height: auto;
        min-height: 100%;
        background: white;
    }
    .custom-container {
        padding-top: 0px;
        padding-left: 0px;
        padding-right: 0px;
        height: 100vh;
    }

    .main-router {
        min-height: calc(100% - 55px);
        margin-top: 55px;
        background: var(--background-color) !important;
    }

    .main-router2 {
        min-height: 100vh;
        background: white !important;
    }

    .app-container {
        background: var(--background-color) !important;
        height: 100%;
        padding: 0 !important;
    }

    .v-text-field--outlined.v-input--is-focused fieldset {
        border: 2px solid var(--cards-and-tables-text-color) !important;
    }

    .v-text-field .v-input__control {
        color: var(--cards-and-tables-text-color) !important;
    }

    .v-label {
        color: var(--cards-and-tables-text-color) !important;
    }
    .theme--light.v-color-picker .v-color-picker__input input {
        color: black !important;
    }
    input, .v-select__selection, .v-select__selections {
        color: var(--cards-and-tables-text-color) !important;
    }

    fieldset {
        border-color: var(--cards-and-tables-text-color) !important;
    }

    /* .v-input__icon, .v-btn__content {
        color: var(--cards-and-tables-text-color) !important;
    } */
    .theme--light.v-input textarea {
        color: var(--cards-and-tables-text-color) !important;
    }
    .v-input__icon {
        color: red !important;
    }

</style>
